<i18n src="../i18n/store-locator.json" />

<template>
  <div class="store-locator-small">
    <MainTitle :page-title="pageTitle" yellow-backdrop></MainTitle>

    <div class="store-locator-small__map-container">
      <StoreLocatorMap
        :position="currentPosition"
        :selected-store="currentStore"
        :stores="stores"
        :default-map-bounds="defaultMapBounds"
        :default-map-position="defaultMapPosition"
        :defaultMapPosition="defaultMapPosition"
        @update:store="setCurrentStore"
      />

      <StoreLocatorAroundMe @click="setCurrentPosition" />
    </div>

    <div class="store-locator-small__stores-list swiper-container">
      <div class="swiper-wrapper">
        <div
          v-for="store in orderedStores"
          :key="store.id"
          class="store-locator-small__stores-item swiper-slide"
        >
          <StoreLocatorStoreCard :position="currentPosition" :store="store" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper/swiper-bundle';
import StoreLocator from '../mixins/StoreLocator';

export default {
  name: 'StoreLocatorSmall',
  mixins: [StoreLocator],
  mounted() {
    new Swiper('.store-locator-small__stores-list', {
      direction: 'horizontal',
      slidesPerView: 'auto',
    });
  },
};
</script>
